export default "__VITE_ASSET__BMMSe8y2__"